import React from 'react';
import ContentLoader from 'react-content-loader';
import { useLocalStorage } from 'react-use';

const CardLoader = (props) => {
  const DarkMode = useLocalStorage('darkMode');
  return (
    <ContentLoader
      viewBox='0 0 500 715'
      backgroundColor={DarkMode[0] ? '#3c3c3c' : '#eaeced'}
      foregroundColor={DarkMode[0] ? '#252525' : '#ffffff'}
      {...props}
    >
      <circle cx='70.2' cy='45' r='27.3' />
      <rect x='129.9' y='10' width='125.5' height='10' />
      <rect x='129.9' y='30' width='296' height='10' />
      <rect x='129.9' y='50' width='253.5' height='10' />
      <rect x='129.9' y='70' width='212.5' height='10' />

      <circle cx='70.7' cy='165' r='27.3' />
      <rect x='130.4' y='130' width='125.5' height='10' />
      <rect x='130.4' y='150' width='296' height='10' />
      <rect x='130.4' y='170' width='253.5' height='10' />
      <rect x='130.4' y='190' width='212.5' height='10' />

      <circle cx='70.7' cy='285' r='27.3' />
      <rect x='130.4' y='250' width='125.5' height='10' />
      <rect x='130.4' y='270' width='296' height='10' />
      <rect x='130.4' y='290' width='253.5' height='10' />
      <rect x='130.4' y='310' width='212.5' height='10' />

      <circle cx='70.7' cy='405' r='27.3' />
      <rect x='130.4' y='370' width='125.5' height='10' />
      <rect x='130.4' y='390' width='296' height='10' />
      <rect x='130.4' y='410' width='253.5' height='10' />
      <rect x='130.4' y='430' width='212.5' height='10' />

      <circle cx='70.7' cy='525' r='27.3' />
      <rect x='130.4' y='490' width='125.5' height='10' />
      <rect x='130.4' y='510' width='296' height='10' />
      <rect x='130.4' y='530' width='253.5' height='10' />
      <rect x='130.4' y='550' width='212.5' height='10' />

      <circle cx='70.7' cy='645' r='27.3' />
      <rect x='130.4' y='610' width='125.5' height='10' />
      <rect x='130.4' y='630' width='296' height='10' />
      <rect x='130.4' y='650' width='253.5' height='10' />
      <rect x='130.4' y='670' width='212.5' height='10' />
    </ContentLoader>
  );
};

export default CardLoader;
